import * as React from "react";
import { InputProps } from "../../types/InputProps";
// import MaskedInput from "react-text-mask";

import TextField from "@material-ui/core/TextField";

/*
function PhoneFormatCustom(props) {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            mask={[/\d/, /\d/, " ", /\d/, /\d/, " ", /\d/, /\d/, " ", /\d/, /\d/, " ", /\d/, /\d/]}
            placeholderChar={"\u2000"}
            showMask={true}
        />
    );
}
*/

class InputPhone extends React.Component<InputProps> {

    onChange(event) {
        // if ( event.target.value.match(/([0-9]| )*/) ) {
            this.props.onChange(event.target.value, event.target);
        // }
    }

    public render() {
        return (
            <TextField
                className={"InputPhone"}
                disabled={this.props.disabled}
                type="text"
                label={this.props.label ? this.props.label : null}
                placeholder={this.props.placeholder}
                value={this.props.value ? this.props.value : ""}
                error={this.props.error ? this.props.error : false}
                helperText={this.props.legend ? this.props.legend : ""}
                style={{width: "100%"}}
                onChange={this.onChange.bind(this)}
                required={this.props.required}
                InputProps={{
                    // inputComponent: PhoneFormatCustom
                }}
                inputProps={
                    {
                        pattern: "^(?:0|\\(?\\+33\\)?\\s?|0033\\s?)[1-79](?:[\\.\\-\\s]?\\d\\d){4}$",
                        minLength: 10
                    }
                }
            />
        );
    }

}

export default InputPhone;


// WEBPACK FOOTER //
// ./src/components/InputPhone/InputPhone.tsx